import { IHttpApi } from '@cian/http-api/shared';

import { IDeleteOfferFromComparisonResponseSchema } from 'shared/repositories/offers-comparison/entities/delete_offer_from_comparison/DeleteOfferFromComparisonResponseSchema';
import {
  TDeleteOfferFromComparisonRequest,
  TDeleteOfferFromComparisonResponse,
  fetchDeleteOfferFromComparison,
} from 'shared/repositories/offers-comparison/v1/delete-offer-from-comparison';

import { assertUnknownError } from './assert';
import { mapDeleteOfferFromComparisonResponse, mapDeleteOfferFromComparisonResponseError } from './mappers';

export async function deleteOfferFromComparisonRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: TDeleteOfferFromComparisonRequest;
}): Promise<IDeleteOfferFromComparisonResponseSchema> {
  const response = await fetchDeleteOfferFromComparison<
    TDeleteOfferFromComparisonResponse,
    TDeleteOfferFromComparisonResponse
  >({
    httpApi,
    parameters,
    mappers: {
      200: mapDeleteOfferFromComparisonResponse,
      400: mapDeleteOfferFromComparisonResponseError,
    },
  });

  assertUnknownError(response);

  return response.response as IDeleteOfferFromComparisonResponseSchema;
}
